 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPS9780062046253_EPUB_CVI_R1 from '@/components/OEBPS/9780062046253_epub_cvi_r1'
 import LOVE_1 from '@/components/love_1'
 import OEBPS9780062046253_EPUB_TP_R1 from '@/components/OEBPS/9780062046253_epub_tp_r1'
 import OEBPS9780062046253_EPUB_DED_R1 from '@/components/OEBPS/9780062046253_epub_ded_r1'
 import OEBPS9780062046253_EPUB_EPIG_R1 from '@/components/OEBPS/9780062046253_epub_epig_r1'
 import OEBPS9780062046253_EPUB_TOC_R1 from '@/components/OEBPS/9780062046253_epub_toc_r1'
 import OEBPS9780062046253_EPUB_INTRO_R1 from '@/components/OEBPS/9780062046253_epub_intro_r1'
 import OEBPS9780062046253_EPUB_PROLO_R1 from '@/components/OEBPS/9780062046253_epub_prolo_r1'
 import OEBPS9780062046253_EPUB_CH01_R1 from '@/components/OEBPS/9780062046253_epub_ch01_r1'
 import OEBPS9780062046253_EPUB_CH02_R1 from '@/components/OEBPS/9780062046253_epub_ch02_r1'
 import OEBPS9780062046253_EPUB_CH03_R1 from '@/components/OEBPS/9780062046253_epub_ch03_r1'
 import OEBPS9780062046253_EPUB_CH04_R1 from '@/components/OEBPS/9780062046253_epub_ch04_r1'
 import OEBPS9780062046253_EPUB_CH05_R1 from '@/components/OEBPS/9780062046253_epub_ch05_r1'
 import OEBPS9780062046253_EPUB_CH06_R1 from '@/components/OEBPS/9780062046253_epub_ch06_r1'
 import OEBPS9780062046253_EPUB_CH07_R1 from '@/components/OEBPS/9780062046253_epub_ch07_r1'
 import OEBPS9780062046253_EPUB_CH08_R1 from '@/components/OEBPS/9780062046253_epub_ch08_r1'
 import OEBPS9780062046253_EPUB_CH09_R1 from '@/components/OEBPS/9780062046253_epub_ch09_r1'
 import OEBPS9780062046253_EPUB_EPIL_R1 from '@/components/OEBPS/9780062046253_epub_epil_r1'
 import LOVE_2 from '@/components/love_2'
 import OEBPS9780062046253_EPUB_BIB_R1 from '@/components/OEBPS/9780062046253_epub_bib_r1'
 import OEBPS9780062046253_EPUB_ACK_R1 from '@/components/OEBPS/9780062046253_epub_ack_r1'
 import OEBPS9780062046253_EPUB_ATA_R1 from '@/components/OEBPS/9780062046253_epub_ata_r1'
 import OEBPS9780062046253_EPUB_COP_R1 from '@/components/OEBPS/9780062046253_epub_cop_r1'
 import OEBPSABOUT_THE_PUBLISHER from '@/components/OEBPS/About_the_Publisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/9780062046253_epub_cvi_r1",
 			"name" : "OEBPS/9780062046253_epub_cvi_r1",
 			"component" : OEBPS9780062046253_EPUB_CVI_R1
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/OEBPS/9780062046253_epub_tp_r1",
 			"name" : "OEBPS/9780062046253_epub_tp_r1",
 			"component" : OEBPS9780062046253_EPUB_TP_R1
 		},
 		{
 			"path" : "/OEBPS/9780062046253_epub_ded_r1",
 			"name" : "OEBPS/9780062046253_epub_ded_r1",
 			"component" : OEBPS9780062046253_EPUB_DED_R1
 		},
 		{
 			"path" : "/OEBPS/9780062046253_epub_epig_r1",
 			"name" : "OEBPS/9780062046253_epub_epig_r1",
 			"component" : OEBPS9780062046253_EPUB_EPIG_R1
 		},
 		{
 			"path" : "/OEBPS/9780062046253_epub_toc_r1",
 			"name" : "OEBPS/9780062046253_epub_toc_r1",
 			"component" : OEBPS9780062046253_EPUB_TOC_R1
 		},
 		{
 			"path" : "/OEBPS/9780062046253_epub_intro_r1",
 			"name" : "OEBPS/9780062046253_epub_intro_r1",
 			"component" : OEBPS9780062046253_EPUB_INTRO_R1
 		},
 		{
 			"path" : "/OEBPS/9780062046253_epub_prolo_r1",
 			"name" : "OEBPS/9780062046253_epub_prolo_r1",
 			"component" : OEBPS9780062046253_EPUB_PROLO_R1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js